import React from 'react';
import styled from '@emotion/styled';

const IconWrapper = styled.span`
  color: #4694ce;
`;

const Svg = styled.svg`
  width: 1.2em;
  height: 1.2em;
`;

export const DeleteCrossIcon = () => {
  return (
    <IconWrapper>
      <Svg viewBox='0 0 16 16'>
        <path
          d='M1678,1371a8,8,0,1,0,8,8A8,8,0,0,0,1678,1371Zm2.495,12.29-2.391-2.48-2.346,2.522-1.705-1.585,2.432-2.615-2.479-2.57,1.676-1.617,2.391,2.479,2.346-2.522,1.705,1.586-2.432,2.615,2.479,2.571Z'
          transform='translate(-1670 -1371)'
        />
      </Svg>
    </IconWrapper>
  );
};

export default DeleteCrossIcon;
